import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  image: 'https://cdn.magicpatterns.com/uploads/dZXcuaBHXaAGNCx4nTmLWZ/1.png',
  alt: 'Testimonio - Primer pedido COP 89,9 mil'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/78iEDP88BA9aL39vhAFffU/2.png',
  alt: 'Testimonio - Ventas COP 124,9 mil'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/fN3cdCsXt1Zro1vRUc5jTB/3.png',
  alt: 'Testimonio - Ventas COP 1,5M'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/uvvrjumsXYxDBaxTM8a5zU/4.png',
  alt: 'Testimonio - Facturación 1.303.100'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5yeiLkdHQKQovEvM1c48tb/5.png',
  alt: 'Testimonio - Ventas COP 6,24M'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5qoDZ5BQG3SWasYya4BX47/6.png',
  alt: 'Testimonio - Ventas COP 10,06M'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5vVxC9gE32VYsPBMmM7mNP/7.png',
  alt: 'Testimonio - Ventas COP 4,98M - 55 pedidos en 1 día'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/kU7NQfSMVdhgfEc7okLqBN/8.png',
  alt: 'Testimonio - Casi $10,000 USD en 11 días'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/iW2Jj8koJDMnMJTzrf7fRa/11.png',
  alt: 'Testimonio - $41,000 USD en 6 meses'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/tteoi6KrL8hVYbZNatm1wi/12.jpg',
  alt: 'Testimonio - Facturación $13,4M x4 en un mes'
}];
export function Testimonials() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-113">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="text-center mb-12" data-id="element-114">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4" data-id="element-115">
          Resultados Reales de Nuestros Operadores
        </h2>
        <p className="text-gray-400 font-medium text-lg max-w-2xl mx-auto" data-id="element-116">
          Esto es lo que pasa cuando dejás de mirar y empezás a ejecutar.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-117">
        {testimonials.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.08
      }} className="bg-[#0A0A0A] border border-[#1F1F1F] rounded-2xl overflow-hidden hover:border-primary/30 transition-colors group" data-id="element-118">
            <img src={item.image} alt={item.alt} className="w-full h-auto object-cover group-hover:scale-[1.02] transition-transform duration-300" data-id="element-119" />
          </motion.div>)}
      </div>
    </section>;
}